// extracted by mini-css-extract-plugin
export default {"container":"folders_dropdown_choose_container-module__container--2Jv_C"};